import { useEffect, useState } from "react";
import axios from 'axios';
import { useNavigate, useLocation } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_URL || process.env.REACT_APP_LOCAL_API_URL

function DeleteUser() {
    const [errMsg, setErrMsg] = useState('');
    const [successMsg, setSuccessMsg] = useState('');
    const [account, setAccount] = useState(null);
    const [busy, setBusy] = useState(false);
    const [password, setPassword] = useState('');
    const { state } = useLocation();
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!account || busy || successMsg) return;
        setBusy(true);

        const resetInput = () => {
            setPassword('');
        }

        try {
            const response = await axios.delete(`${API_URL}/users/delete-user`, {
                headers: {
                    "Content-Type": "application/json",
                    'token': localStorage.getItem("token")
                },
                data: {
                    userToDelete: account.username,
                    adminPassword: password
                }
            });
            setSuccessMsg('Användare raderad');
            setErrMsg('');
            resetInput();
            return response.data;

        } catch (error) {
            if (error.response) {
                setErrMsg(error.response.data.message);
            } else {
                setErrMsg('Något gick fel');
            }
            setSuccessMsg('');
            resetInput();
        } finally { setBusy(false); }
    };

    const username = state?.username;
    useEffect(() => {
        let active = true;
        if (!username) { setErrMsg('Välj en användare i användarhanteringen först.'); return; }
        axios.get(`${API_URL}/users/list-users`, { headers: { token: localStorage.getItem('token') } })
            .then(({ data }) => {
                if (!active) return;
                const target = data.userData.find(item => item.username === username);
                if (!target) { setErrMsg('Användaren finns inte längre.'); return; }
                setAccount(target);
            })
            .catch(() => { if (active) setErrMsg('Kunde inte hämta användaren.'); });
        return () => { active = false; };
    }, [username]);

    return (
        <>
            <div className="flex flex-col items-center mx-2">
                <div className="theme-card mx-4 my-4 w-full max-w-2xl p-4">
                    <form onSubmit={handleSubmit} className="flex flex-col items-center pt-4 pb-4">
                        <p className="text-center text-xs font-semibold uppercase tracking-[0.2em] text-red-600">Administration</p>
                        <h1 className="mt-2 text-center text-lg font-bold text-slate-800">Radera användare</h1>

                        <div className="mt-4 flex w-full justify-center">
                            <div className="w-full break-words text-center">
                                <p className="font-semibold">{account?.name || account?.email}</p>
                                <p className="break-all">{account?.email}</p>
                            </div>
                        </div>

                        <div className="flex w-full flex-col items-center">
                            <p className="text-center text-sm text-slate-600">Bekräfta genom att ange ditt lösenord</p>
                            <input className="theme-input my-2 w-72"
                                onChange={(e) => setPassword(e.target.value)}
                                type="password"
                                value={password}
                                placeholder='Lösenord'
                                autoComplete="off"
                                required />
                        </div>
                        <div className="flex w-full justify-center">
                            <button disabled={!account || busy || Boolean(successMsg)} className="theme-button-danger my-3 flex w-72 justify-center">Radera användare</button>
                        </div>

                        {errMsg && <p className="theme-alert-error flex justify-center">{errMsg}</p>}
                        {successMsg && <p className="theme-alert-success flex justify-center">{successMsg}</p>}
                    </form>
                    <button className="theme-button-secondary my-3 w-72 text-center" onClick={() => navigate("/user-management")}>Tillbaka</button>
                </div>
            </div>

        </>
    );
}

export default DeleteUser;
